import React from "react";

import TrimetLegIcon from "../trimet-leg-icon";

import LegIconRenderer from "./leg-icon-renderer";

export default {
  title: "Icons/TrimetLegIcon",
  component: TrimetLegIcon
};

export const Trimetxamples = () => (
  <LegIconRenderer component={TrimetLegIcon} />
);
